import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { DatePicker } from "./DatePicker";
import { MenuCalendar } from "./MenuCalendar";
import { getImage } from "./utils";
import { Select } from "../uikit/Select";
import { Context } from "../context";

function DayFiltersInner({ history }) {
  const context = useContext(Context);

  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);

  const getProjectData = (dataType = "projects", oneProjectId, field) => {
    let data = context.data[dataType].filter(
      (one) => one["uniq"] === oneProjectId
    )[0];
    return !field && data ? data : data && data[field] ? data[field] : '';
  };

  const selectColors = {
    idle: `#Ffcfcfc`,
    // idle: `#FFF`,
    accent: `var(--main-accent-color)`,
    radius: "4px",
  };

  const codeFilterToHash = (filtersArray) => {
    let hash = `${filtersArray.map((filterName, i) => {
      if (i === filtersArray.length - 1) {
        return filterName;
      } else {
      }
      return `${filterName}`;
    })}`;
    return hash;
  };

  const drawMultiselectColors = (filterType, array, img = true, color) => {
    return array.map((oneId) => (
      <>
        {/* <div className="x_project0 x_project0--select"> */}
        <div className="x_project_ava x_project_ava--mini">
          <div
            // src="https://assets.website-files.com/61785133118e574036320746/617ba6f68653f362ba29a9ba_Screen%20Shot%202021-10-29%20at%2012.46.34%20AM.png"
            alt=""
            className="x_project_ava_img"
            style={{
              backgroundImage: img
                ? `url(${getImage(getProjectData(filterType, oneId, "img"))})`
                : "",
              backgroundColor: color
                ? getProjectData(filterType, oneId, "color")
                : "",
            }}
          />
        </div>
        {/* <div href="#" className="x_project_title">
            <div>RC Car #4 Europe Launch</div>
          </div> */}
        {/* <div
            className="x_project0_bg"
            style={
              {
                // backgroundColor: context.handles.getColorData(oneColorName, "name")[
                //   "color"
                // ],
              }
            }
          /> */}
        {/* </div> */}

        {/* <div
          key={`color_${oneColorName}`}
          className="filt_color"
          style={{
            flex: 'none',
            // backgroundColor: context.handles.getColorData(oneColorName, "name")[
            //   "color"
            // ],
          }}
        ></div>
        &nbsp;&nbsp; */}
      </>
    ));
  };

  const handleFilter = (val, filterType = "users") => {
    let filter = [];
    if (filterType === "projects") filter = context.state["activeProjects"];
    if (filterType === "users") filter = context.state["activeUsers"];

    let temporaryFilters = [...JSON.parse(JSON.stringify(filter))];
    if (!temporaryFilters.filter((oneEl) => oneEl === val).length) {
      temporaryFilters = [...filter, val];
    } else {
      temporaryFilters = [...temporaryFilters.filter((oneEl) => oneEl !== val)];
    }

    if (!temporaryFilters.length) {
      resetFilter("color");
    } else {
      if (filterType === "projects")
        context.handles.setActiveProjects(temporaryFilters);
      if (filterType === "users")
        context.handles.setActiveUsers(temporaryFilters);

      history.push({
        // hash: `${'users'}:${codeFilterToHash(temporaryFilters, users)}`,
        hash: `u:${codeFilterToHash(temporaryFilters)}`,
      });
    }
  };

  const resetFilter = (filterType = "color") => {
    setProjects([]);
    // history.push({ hash: `` });
  };

  return (
    <div className="l_filters">
      <div className="l_filters_grid">
        <div className="l_filter_section">
        <div className="c_m_section">
          {/* <DatePicker/> */}
          <MenuCalendar />
        </div>
        </div>
        <div className="l_filter_section">
        <div className="c_m_section">
          <div className="x_filters_title">People</div>

          <Select
            dropStyle={{
              display: "flex",
              flexDirection: "column",
              // flexDirection: "row",
              // flexWrap: "wrap",
              // width: 360,
              justifySelf: "stretch",
              borderRadius: "0.6em",
              padding: "0.4em 0.6em",
            }}
            dropItemStyle={{
              borderRadius: "0.4em",
              padding: "0.4em 1em",
              margin: "0.2em",
              minHeight: 32,
            }}
            colors={{ ...selectColors }}
            // handleReset={
            //   Boolean(filter.length) ? () => resetFilter("color") : false
            // }
            multiSelect={true}
            width={220}
            // size="sm"
            placeholder="All colors"
            // active = {filter.length ? filter[0] : null }
            active={
              context.state["activeUsers"].length
                ? context.state["activeUsers"]
                : ""
            }
            activeCustom={
              context.state["activeUsers"].length
                ? drawMultiselectColors(
                    "users",
                    context.state["activeUsers"],
                    true,
                    false
                  )
                : null
            }
            menuHandler={(val) => {
              // console.log("history = ", history);
              // console.log("match = ", match);
              // console.log("location = ", location);
              handleFilter(val, "users");
            }}
            options={[
              ...context["data"]["users"].map((user) => {
                return {
                  // title: <>{tag["title"]} - {filterByCategory(tag['items'], category).length}</>,
                  title: <>{user["name"]}</>,
                  // icon: <MIcon size={18}>add</MIcon>,
                  icon: (
                    <div
                      className="x_project_ava_img"
                      style={{
                        // backgroundColor: user["color"], margin: 0,
                        backgroundImage: `url(${getImage(user["img"], "small")})`,
                      }}
                    >
                      {/* {project["icon"]} */}
                    </div>
                  ),
                  value: user["uniq"],
                  // separated: true,
                };
              }),
            ]}
          />
        </div>
        </div>
        <div className="l_filter_section">
        <div className="c_m_section">
          <div className="x_filters_title">Projects</div>

          <Select
            dropStyle={{
              display: "flex",
              flexDirection: "column",
              // flexDirection: "row",
              // flexWrap: "wrap",
              // width: 360,
              justifySelf: "stretch",
              borderRadius: "0.6em",
              padding: "0.4em 0.6em",
            }}
            dropItemStyle={{
              borderRadius: "0.4em",
              padding: "0.4em 1em",
              margin: "0.2em",
              minHeight: 32,
            }}
            colors={{ ...selectColors }}
            // handleReset={
            //   Boolean(filter.length) ? () => resetFilter("color") : false
            // }
            multiSelect={true}
            width={220}
            // size="sm"
            placeholder="All colors"
            // active = {filter.length ? filter[0] : null }
            active={
              context.state["activeProjects"].length
                ? context.state["activeProjects"]
                : ""
            }
            activeCustom={
              context.state["activeProjects"].length
                ? drawMultiselectColors(
                    "projects",
                    context.state["activeProjects"],
                    true,
                    true
                  )
                : null
            }
            menuHandler={(val) => {
              // console.log("history = ", history);
              // console.log("match = ", match);
              // console.log("location = ", location);
              handleFilter(val, "projects");
            }}
            options={[
              ...context["data"]["projects"].map((project) => {
                return {
                  // title: <>{tag["title"]} - {filterByCategory(tag['items'], category).length}</>,
                  title: <>{project["title"]}</>,
                  // icon: <MIcon size={18}>add</MIcon>,
                  icon: (
                    <div
                      className="x_project_ava_img"
                      style={{
                        backgroundColor: project["color"],
                        margin: 0,
                        backgroundImage: `url(${getImage(project["img"])})`,
                      }}
                    >
                      {/* {project["icon"]} */}
                    </div>
                  ),
                  value: project["uniq"],
                  // separated: true,
                };
              }),
            ]}
          />

          {/* <div className="c_m_ul">
                      <div className="c_m_li">
                        <div className="c_m_check">
                          <div className="x_color_teal">check_box</div>
                        </div>
                        <div className="c_m_check_label">
                          <div>RC Racer 2021</div>
                        </div>
                      </div>
                      <div className="c_m_li">
                        <div className="c_m_check">
                          <div>check_box_outline_blank</div>
                        </div>
                        <div className="c_m_check_label">
                          <div>Industrial Design Org</div>
                        </div>
                      </div>
                      <div className="c_m_li">
                        <div className="c_m_check">
                          <div className="x_color_blue">check_box</div>
                        </div>
                        <div className="c_m_check_label">
                          <div>2021 US&nbsp;Toy Dev</div>
                        </div>
                      </div>
                      <div className="c_m_li">
                        <div className="c_m_check">
                          <div>check_box_outline_blank</div>
                        </div>
                        <div className="c_m_check_label">
                          <div>Global Ops</div>
                        </div>
                      </div>
                      <div className="c_m_li">
                        <div className="c_m_check">
                          <div className="x_color_blue2">check_box</div>
                        </div>
                        <div className="c_m_check_label">
                          <div>Malaysia Supply</div>
                        </div>
                      </div>
                    </div> */}
        </div>
        </div>
      </div>
    </div>
  );
}

export const DayFilters = withRouter(DayFiltersInner);
